<template>
  <el-dialog
    :close-on-click-modal="false"
    custom-class="question-review-msg-box"
    :title="title"
    :visible.sync="visible">

    <error-message-list
      v-model="errorMsg"
      :messages="messages"/>

    <el-input :autosize="{ minRows: 1}"
              type="textarea"
              placeholder="请输入不通过原因"
              v-model="errorMsg"
              resize="none">
    </el-input>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="danger"
                 :disabled="!errorMsg"
                 @click="onNotPassedAudit">确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ErrorMessageList from './ErrorMessageList'

export default {
  mixins: [],
  components: {ErrorMessageList},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: Function.prototype,
    },
    title: String,
    messages: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      errorMsg: '',
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (val) {
        document.addEventListener('keydown', this.keydownEnter)
      } else {
        document.removeEventListener('keydown', this.keydownEnter)
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {
    document.removeEventListener('keydown', this.keydownEnter)
  },
  methods: {
    onNotPassedAudit () {
      this.$emit('update:visible', false)
      this.callback(this.errorMsg)
    },
    keydownEnter (event) {
      let keyCode = event.keyCode || event.which || event.charCode
      // enter
      if (keyCode === 13 && this.errorMsg) {
        this.onNotPassedAudit()
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/QuestionNotPassed.vue